"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Notebook;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Notebook(_ref) {
  var {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "37",
    height: "48",
    viewBox: "0 0 37 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.0374 33.2461H28.6505",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.56917 35.4479C9.92564 35.4479 11.0253 34.3482 11.0253 32.9917C11.0253 31.6352 9.92564 30.5356 8.56917 30.5356C7.21269 30.5356 6.11304 31.6352 6.11304 32.9917C6.11304 34.3482 7.21269 35.4479 8.56917 35.4479Z",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.0374 24.1089H28.6505",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.56917 26.3107C9.92564 26.3107 11.0253 25.2111 11.0253 23.8546C11.0253 22.4981 9.92564 21.3984 8.56917 21.3984C7.21269 21.3984 6.11304 22.4981 6.11304 23.8546C6.11304 25.2111 7.21269 26.3107 8.56917 26.3107Z",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.0374 14.9722H28.6505",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.56917 17.1657C9.92564 17.1657 11.0253 16.0661 11.0253 14.7096C11.0253 13.3531 9.92564 12.2534 8.56917 12.2534C7.21269 12.2534 6.11304 13.3531 6.11304 14.7096C6.11304 16.0661 7.21269 17.1657 8.56917 17.1657Z",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.4589 44.3374C34.4589 44.9035 34.2345 45.4465 33.835 45.8475C33.4354 46.2485 32.8932 46.4748 32.3271 46.4769H3.13944C2.57203 46.4769 2.02785 46.2515 1.62663 45.8503C1.2254 45.449 1 44.9049 1 44.3374V3.13175C0.999998 2.85116 1.0554 2.57331 1.16302 2.31418C1.27063 2.05504 1.42833 1.8197 1.6271 1.62164C1.82587 1.42359 2.06178 1.26673 2.3213 1.16006C2.58083 1.05339 2.85885 0.998997 3.13944 1.00001H32.3271C32.8925 1.00001 33.4347 1.2246 33.8345 1.62438C34.2343 2.02416 34.4589 2.56638 34.4589 3.13175V37.3244",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.0001 37.3013C37.0012 37.6357 36.9362 37.9669 36.8089 38.2761C36.6817 38.5853 36.4947 38.8664 36.2586 39.1031C36.0225 39.3399 35.7421 39.5278 35.4333 39.656C35.1245 39.7841 34.7934 39.8501 34.4591 39.8501C34.1247 39.8501 33.7936 39.7841 33.4848 39.656C33.176 39.5278 32.8956 39.3399 32.6595 39.1031C32.4235 38.8664 32.2364 38.5853 32.1092 38.2761C31.9819 37.9669 31.917 37.6357 31.918 37.3013C31.918 36.6274 32.1857 35.981 32.6622 35.5045C33.1388 35.028 33.7851 34.7603 34.4591 34.7603C35.133 34.7603 35.7793 35.028 36.2559 35.5045C36.7324 35.981 37.0001 36.6274 37.0001 37.3013Z",
    fill: "#54C8E8"
  }));
}